import React, { useEffect, useRef, useState } from 'react'
import Downshift from 'downshift'
import { Placeholder } from 'react-bootstrap'
import CustomCheckbox from '../Checkbox'
import { FilterClose } from '../SVGIcons'
import './index.scss'
import { useDispatch } from 'react-redux'
import { actionSearchUserByName } from '../../actions/Dashboard/UserManagement'
import { SnackMessages } from '../Toast'

let timeout = 0;
export const PickUserWithSuggestions = ({ placeholder, setMenuOpen, menuIsOpen, handleSearchFilter, userRole, className, activeItems, userGroupId }) => {
    const dispatch = useDispatch()
    const [menuList, setMenuList] = useState([])
    const [listLoader, setListLoader] = useState(false)
    const [loadingMore, setLoadingMore] = useState(false)
    const [pagination, setPagination] = useState({ page: 1, lastPage: 1, total: 0 })
    const [searchValue, setSearchValue] = useState('')
    const { showErrorMessage } = SnackMessages();
    const listRef = useRef(null)

    const fetchStyles = (item) => isItemExist(item?.id, item?.customerName) ? 'active' : ''

    const isItemExist = (id, label) => {
        if (!activeItems?.length) return false;
        return activeItems.some(item => item?.id === id || item?.customerName === label || item?.label === label);
    };

    const fetchUsers = async (page = 1, search = '', append = false) => {
        if (page === 1 && !append) {
            setListLoader(true);
        } else {
            setLoadingMore(true);
        }

        const payload = {
            page,
            limit: 10,
            ...(search ? { search } : {}),
            ...(userRole ? { role_id: userRole } : {}),
            ...(userGroupId ? { user_group_id: userGroupId } : {}),
        };

        const res = await dispatch(actionSearchUserByName(payload));
        setListLoader(false);
        setLoadingMore(false);

        if (!res.success) {
            showErrorMessage(res.message);
            return;
        }

        const responseData = res?.response;
        // Handle array response structure or paginated object structure
        let rawUsers = [];
        let curPage = 1;
        let lastPg = 1;

        if (Array.isArray(responseData)) {
            rawUsers = responseData;
        } else if (responseData?.data && Array.isArray(responseData.data)) {
            rawUsers = responseData.data;
            curPage = responseData.current_page || page;
            lastPg = responseData.last_page || 1;
        }

        const formatted = rawUsers.map(item => ({
            ...item,
            isChecked: Boolean(item?.isChecked) || isItemExist(item?.id, item?.customerName),
        }));

        setPagination({
            page: curPage,
            lastPage: lastPg,
            total: responseData?.total || rawUsers.length,
        });

        if (append) {
            setMenuList(prev => {
                const combined = [...prev, ...formatted];
                // filter duplicates by id
                return [...new Map(combined.map(u => [u.id, u])).values()];
            });
        } else {
            setMenuList(formatted);
        }
    };

    useEffect(() => {
        // Initial fetch on component mount / drawer open
        fetchUsers(1, '');
    }, [userGroupId, userRole]);

    const handleChooseItem = (element) => {
        if (!element) return;
        handleSearchFilter(placeholder, element);
    };

    const handleCloseList = () => {
        setMenuOpen(false);
    };

    const onInputValueChange = (selection, stateAndHelpers) => {
        if (selection !== undefined && stateAndHelpers?.type === Downshift.stateChangeTypes.changeInput) {
            setSearchValue(selection);
            setMenuOpen(true);

            if (timeout) clearTimeout(timeout);
            timeout = setTimeout(() => {
                fetchUsers(1, selection, false);
            }, 500);
        }
    };

    const handleScroll = (e) => {
        const target = e.target;
        const reachedBottom = target.scrollHeight - target.scrollTop <= target.clientHeight + 20;

        if (reachedBottom && !loadingMore && pagination.page < pagination.lastPage) {
            fetchUsers(pagination.page + 1, searchValue, true);
        }
    };

    return (
        <div className={`search-select ${className ? className : ''}`} >
            <Downshift
                onOuterClick={handleCloseList}
                isOpen={menuIsOpen}
                onSelect={(selection) => handleChooseItem(selection)}
                onInputValueChange={onInputValueChange}
                itemToString={item => (item ? item.customerName?.toLowerCase() : '')}>
                {({
                    getInputProps,
                    getItemProps,
                    getMenuProps,
                    isOpen,
                    clearSelection,
                }) => (
                    <div className='search-filter'>
                        <input
                            {...getInputProps({
                                onFocus: () => setMenuOpen(true),
                            })}
                            placeholder={placeholder}
                            className="form-control"
                        />
                        {<>
                            {listLoader ? <CustomLoader /> : (
                                <ul
                                    {...getMenuProps()}
                                    ref={listRef}
                                    onScroll={handleScroll}
                                    style={{ maxHeight: '400px', overflowY: 'auto' }}
                                >
                                    {isOpen && <>
                                        {menuList?.length > 0 ? (
                                            <>
                                                {menuList.map((item, index) => (
                                                    <li
                                                        {...getItemProps({
                                                            key: item.id || index,
                                                            index,
                                                            item,
                                                        })}
                                                        className={`search-list ${fetchStyles(item)}`}
                                                    >
                                                        <CustomCheckbox
                                                            variant="labelled"
                                                            checked={Boolean(isItemExist(item?.id, item?.customerName))}
                                                            label={item?.customerName || `${item?.first_name || ''} ${item?.last_name || ''}`.trim()}
                                                            onChange={() => {}}
                                                        />
                                                    </li>
                                                ))}
                                                {loadingMore && (
                                                    <div className="p-2 text-center text-muted" style={{ fontSize: '12px' }}>
                                                        Loading more...
                                                    </div>
                                                )}
                                            </>
                                        ) : (
                                            <div className='user-not-found'>
                                                <p>No User found</p>
                                            </div>
                                        )}
                                    </>}
                                </ul>
                            )}
                            {isOpen && <div className='suggestion-close '>
                                <FilterClose onMouseDown={(e) => {
                                    e.preventDefault();
                                    clearSelection();
                                    setSearchValue('');
                                    fetchUsers(1, '', false);
                                }} />
                            </div>}
                        </>}
                    </div>
                )}
            </Downshift>
        </div>
    )
}

const CustomLoader = () => {
    return (
        <div className=' gap-2 custom-loader'>
            {Array.from(Array(4).keys()).map(load => (
                <Placeholder key={load} animation="glow">
                    <Placeholder className="w-100 p-3 gap-2 mt-2" />
                </Placeholder>
            ))}
        </div>
    )
}